const defaultAvatars = state => state.defaultAvatars;

export {
  defaultAvatars,
}